import { GeneratedZone } from 'store/types/types';
import { convert, inferUnit } from 'util/unitConversion';
import { Feature } from 'manual/types';

export const parseGeneratedZonesFromUAPI = (features: Feature[]) => {
  const zones = {} as Record<string, GeneratedZone>;

  features.forEach((feature, index) => {
    const zoneId = `zone-${index}`;
    const isDeadZone = feature.properties.isDeadZone;

    zones[zoneId] = {
      geoJson: {
        geometry: feature.geometry,
        type: feature.type,
        properties: {
          // Relative productivity is not shown for dead zones
          relativeProductivity: isDeadZone ? null : feature.properties.relativeProductivity,
          isDeadZone,
          yieldPerCrop: feature.properties.yieldPerCrop,
          averageCCI: feature.properties.averageCCI
        }
      },
      meta: {
        area: convert({
          from: { q: feature.properties.area.v, u: feature.properties.area.u },
          to: { u: inferUnit('area').unitKey },
          precision: 5
        }),
        geometry: feature.geometry,
        index,
        zoneId
      }
    };
  });

  return zones;
};
